import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import SimulationMonitorLogTable from './table/SimulationMonitorLogTable';
import SimulationMonitorLogEditForm from './editform/SimulationMonitorLogEditForm';

i18next.addResourceBundle('en', 'simulationMonitorLog', en);
i18next.addResourceBundle('hu', 'simulationMonitorLog', hu);

export default [
	{
		path: '/simulation-monitor-log/edit/:id/:tabKey?',
		component: SimulationMonitorLogEditForm,
		auth: authRoles.simulationMonitorLog
	},
	{
		path: '/simulation-monitor-log/:sessionNameParam?',
		component: SimulationMonitorLogTable,
		auth: authRoles.simulationMonitorLog
	}
];
